export const FILTER_INFO_PREFIX = 'filter.';

export const FILTER_INFO_ALIASES = {
  companyId: 'company',
  companyName: 'company',
  preset: 'period',
  from: 'period',
  to: 'period',
  saleFrom: 'salePeriod',
  saleTo: 'salePeriod',
  salePreset: 'salePeriod',
};

export const filterInfoKey = (filterKey) => {
  if (typeof filterKey !== 'string' || !filterKey) return '';
  const name = Object.prototype.hasOwnProperty.call(FILTER_INFO_ALIASES, filterKey) ? FILTER_INFO_ALIASES[filterKey] : filterKey;
  return FILTER_INFO_PREFIX + name;
};

export const FILTERS_GLOSSARY = [
  {
    key: 'filter.period',
    label: 'Período',
    whatIs: 'Intervalo de dias que a tela lê: 7, 30 ou 90 dias terminando ontem, ou datas escolhidas em "Personalizado" (até 400 dias, sem passar de hoje). O padrão é 30 dias até ontem.',
    purpose: 'Define o recorte de tempo de todos os blocos da tela. Use 7 dias para efeito recente, 30 para o mês móvel e 90 ou personalizado para tendência e sazonalidade.',
    howGenerated: 'Cada dia é o dia local da empresa (fuso do cadastro). Contagens somam os dias; ativos no dia saem como média; números de 30 dias, como ativos e adoção, são a foto do último dia fechado do período.',
    caveat: 'Os atalhos deixam hoje de fora porque o dia não fechou; um período personalizado que inclui hoje sai "Parcial". Antes do início da coleta o número é retroativo ou não existe.',
    seeAlso: ['filter.compare', 'common.coverage'],
  },
  {
    key: 'filter.compare',
    label: 'Comparar com o período anterior',
    whatIs: 'Liga a comparação de cada número com o período anterior: o mesmo número de dias, logo antes do período escolhido (os 30 dias antes dos 30 dias, por exemplo). Vem ligado.',
    purpose: 'Mostra se o número subiu ou caiu e quanto, para separar mudança real de oscilação comum antes de tirar conclusão.',
    howGenerated: 'O PI calcula os mesmos números no período anterior e mostra a diferença absoluta e a percentual (↑ ↓). Em taxas, a diferença sai em pontos percentuais (p.p.). Sem valor anterior, aparece "Sem base de comparação".',
    caveat: 'A variação percentual só sai quando o valor anterior é maior que zero. Na Ativação, a comparação é com as vendas do período anterior de mesmo tamanho.',
    seeAlso: ['common.delta'],
  },
  {
    key: 'filter.company',
    label: 'Empresa',
    whatIs: 'Restringe a tela a uma empresa, escolhida pelo nome ou pelo identificador (a busca começa com 2 letras).',
    purpose: 'Ler o uso de uma conta com as mesmas métricas do total, por exemplo antes de uma reunião com o cliente ou para conferir uma reclamação.',
    howGenerated: 'Os números da empresa são recalculados na hora a partir do uso diário de cada usuário dela, com as mesmas regras de ativo e em uso. Na Ativação, abre o bloco da empresa com os marcos e as datas.',
    caveat: 'Com uma empresa escolhida, porte e perfil da empresa não se aplicam. Telas sem este filtro avisam em "Não se aplica a esta visão".',
  },
  {
    key: 'filter.module',
    label: 'Módulo',
    whatIs: 'Restringe a uma das 11 áreas do catálogo de eventos do produto, como Controle de Jornada, Departamento Pessoal ou Documentos e Assinaturas.',
    purpose: 'Ver quanto do uso vem de um módulo: quantas pessoas agiram nele, quais funcionalidades dele são adotadas e como vão as operações dele.',
    howGenerated: 'A pessoa conta no dia em que teve pelo menos um evento de uma ação do módulo, segundo o catálogo de eventos. Nas listas de funcionalidades e de operações, mostra só as do módulo.',
    caveat: 'Vale um corte por vez: junto com papel do usuário, plataforma, porte ou perfil da empresa, o número sai "n/d". Com módulo, o denominador de assentos é o total de habilitados.',
    seeAlso: ['common.state.na'],
  },
  {
    key: 'filter.featureType',
    label: 'Funcionalidade',
    whatIs: 'Restringe a uma funcionalidade do catálogo do PI, como Férias, Assinatura de documentos ou Relatório avançado.',
    purpose: 'Isolar uma funcionalidade nos números da tela. Para estudar uma só a fundo, o detalhe da funcionalidade é o caminho mais completo.',
    howGenerated: 'Usa o número da funcionalidade no catálogo do PI (o mesmo de "Status e catálogo"); a lista de adoção passa a mostrar só ela.',
    caveat: 'Nas telas que não usam este filtro, ele aparece em "Não se aplica a esta visão" e não muda os números.',
  },
  {
    key: 'filter.roleClass',
    label: 'Papel do usuário',
    whatIs: 'Restringe às pessoas de um papel: Funcionário, Gestor (funcionário responsável por pelo menos uma equipe), Admin ou Contador.',
    purpose: 'Comparar o uso de quem bate ponto com o de quem aprova e administra, e achar funcionalidades que só um papel adota.',
    howGenerated: 'O papel vem do cadastro do usuário no retrato diário: funcionário sem equipe, funcionário com equipe (gestor), os dois perfis de administrador (admin) ou contador. Ativos, habilitados e elegíveis passam a contar só esse papel.',
    caveat: 'Vale um corte por vez: junto com plataforma, módulo, porte ou perfil da empresa, o número sai "n/d". Gestor vem da equipe, não de um perfil de acesso próprio.',
  },
  {
    key: 'filter.platform',
    label: 'Plataforma',
    whatIs: 'Restringe a um canal de uso: Web, Web V2, app, tablet, QR Code, modo ponto, reconhecimento facial, Express, API pública, sistema, relógio de ponto (REP), WhatsApp ou desconhecida.',
    purpose: 'Ver por onde as pessoas usam o produto e medir a migração entre canais, como do painel antigo para a Web V2 ou do relógio de ponto para o app.',
    howGenerated: 'A pessoa conta no dia em que teve pelo menos um evento registrado naquele canal; o canal vem de quem gravou o evento (aplicativo, tela ou integração). Nas operações, mostra só as tentativas feitas pelo canal.',
    caveat: 'Um corte por vez. A mesma pessoa usa vários canais, então a soma passa do total. Com plataforma, o denominador de assentos é o total de habilitados. Web, Web V2 e Desconhecida têm quebra de série: leia o aviso.',
  },
  {
    key: 'filter.sizeBand',
    label: 'Porte (funcionários)',
    whatIs: 'Faixa de tamanho da empresa pelo número de funcionários do cadastro: A (100 ou mais), B (50 a 99), C (21 a 49), D (11 a 20) e E (até 10).',
    purpose: 'Comparar empresas parecidas: uso, adoção e ativação mudam muito com o tamanho, e a média geral esconde isso.',
    howGenerated: 'Lido do retrato diário da empresa a partir do total de funcionários informado no cadastro, e não dos usuários habilitados. Na Ativação, vale o porte de hoje.',
    caveat: 'Não confunda com o perfil da empresa, que também usa letras de A a E com outra régua. Vale um corte por vez com papel, plataforma, módulo e perfil da empresa.',
    seeAlso: ['filter.segment'],
  },
  {
    key: 'filter.segment',
    label: 'Perfil da empresa',
    whatIs: 'Categoria comercial da empresa, de A a E, gravada no Master (o "Perfil" do detalhe da empresa). Digite a letra exatamente como no cadastro.',
    purpose: 'Ler o uso por categoria de cliente, a mesma que o comercial e o time de sucesso do cliente usam para priorizar o atendimento.',
    howGenerated: 'Compara o texto inteiro com o perfil do detalhe da empresa. A régua padrão é pelo número de funcionários (E até 10, D de 11 a 30, C de 31 a 50, B acima de 50); A e as exceções são escolhas manuais.',
    caveat: 'Empresas sem perfil gravado só aparecem sem o filtro. Vale um corte por vez com papel, plataforma, módulo e porte.',
    seeAlso: ['filter.sizeBand'],
  },
  {
    key: 'filter.granularity',
    label: 'Granularidade',
    whatIs: 'Tamanho de cada ponto das séries do Engajamento: diário (padrão), semanal ou mensal.',
    purpose: 'Suavizar a oscilação entre dias úteis e fim de semana para ver tendência; o diário serve para achar o dia de uma queda ou de um pico.',
    howGenerated: 'No semanal e no mensal, o ponto leva a data do início da semana ou do mês; ativos no dia saem como média dos dias, e ativos em 7 e 30 dias e em uso são os do último dia do intervalo.',
    caveat: 'Só muda as séries; cartões e tabelas continuam iguais. Um ponto com algum dia parcial sai inteiro como parcial.',
  },
  {
    key: 'filter.search',
    label: 'Buscar empresa',
    whatIs: 'Busca na lista de empresas pelo nome ou pelo identificador, a partir de 2 letras.',
    purpose: 'Achar uma conta rapidamente na lista, mantendo os outros filtros e a ordenação.',
    howGenerated: 'Procura o texto em qualquer parte do nome da empresa no retrato mais recente do período. Se o texto só tem números, letras de A a F e hífen, também acha identificadores que começam com ele.',
  },
  {
    key: 'filter.band',
    label: 'Faixa de ativos (30 dias)',
    whatIs: 'Faixa de usuários ativos da empresa nos 30 dias até o último dia fechado do período: sem ativos, 1 a 5, 6 a 20, 21 a 50, 51 a 200 ou mais de 200.',
    purpose: 'Separar contas paradas, pequenas e grandes em uso real, por exemplo para listar quem não teve nenhum ativo e pode estar abandonando o produto.',
    howGenerated: 'Ativo é quem concluiu ação de uso real (bater ponto, ajuste, aprovação, férias, espelho, documento). Conta os ativos distintos na janela móvel de 30 dias; empresas fora do universo ativo ficam de fora com o filtro.',
    caveat: 'É o mesmo número da coluna "Ativos (30 dias)". Clicar numa barra da distribuição de empresas no Engajamento abre a lista com a faixa escolhida.',
    seeAlso: ['common.activeUsers30d'],
  },
  {
    key: 'filter.journey',
    label: 'Jornada',
    whatIs: 'Etapa da empresa na jornada do cliente gravada no Master: Lead, Onboarding, Middle, Ongoing ou Resale (os mesmos nomes da lista de empresas do Master).',
    purpose: 'Cruzar o uso real com a etapa em que o time acha que o cliente está, por exemplo achar empresas em Ongoing sem ativos.',
    howGenerated: 'Lida do cadastro da empresa no retrato mais recente do período. É informativa: o PI não calcula a jornada, só mostra o que o time gravou.',
    caveat: 'Depende de atualização manual e pode estar desatualizada; confira com a última atividade.',
    seeAlso: ['common.journey'],
  },
  {
    key: 'filter.signal',
    label: 'Só com queda de atividade',
    whatIs: 'Mostra só as empresas cujos ativos em 30 dias caíram para 70% ou menos do mesmo número no período anterior, com base de pelo menos 10 ativos.',
    purpose: 'Lista de risco para o time de sucesso do cliente agir antes do cancelamento: quem usava bem e passou a usar bem menos.',
    howGenerated: 'Compara os ativos distintos dos 30 dias até o último dia fechado do período com os dos 30 dias até o último dia fechado do período anterior, de mesmo tamanho. Empresas com menos de 10 ativos antes ficam fora.',
    caveat: 'Empresa sem uso no período nunca é tratada como cancelada. O selo acima da tabela conta só a página aberta.',
    seeAlso: ['common.signalDrop'],
  },
  {
    key: 'filter.contract',
    label: 'Contrato',
    whatIs: 'Separa as empresas pelo uso frente ao contratado: "Usa menos da metade do contratado" (abaixo de 50%) ou "Usa mais que o contratado" (acima de 100%).',
    purpose: 'Achar risco de cancelamento ou de redução (pagam e não usam) e chance de venda adicional (usam mais do que pagam).',
    howGenerated: 'Utilização = ativos habilitados nos 30 dias até o último dia fechado, divididos pelos assentos da assinatura ativa, vezes 100. Empresas sem assinatura ativa ou sem assentos contratados ficam fora com o filtro.',
    caveat: 'Com o filtro de papel do usuário, divide só os ativos daquele papel por todos os assentos.',
    seeAlso: ['common.contractUtilization'],
  },
  {
    key: 'filter.salePeriod',
    label: 'Vendas de',
    whatIs: 'Período da primeira venda (D0) das empresas lidas na Ativação: 3, 6 ou 12 meses até ontem, ou datas escolhidas em "Personalizado" (até 400 dias). O padrão é 6 meses.',
    purpose: 'Escolher quais vendas acompanhar: as recentes mostram a implantação em andamento; as antigas, o resultado já fechado em 15, 30 e 60 dias depois da venda.',
    howGenerated: 'O D0 é a primeira data encontrada: registro de venda, funcionalidade liberada na venda inicial, primeiro pagamento ou criação (se hoje não é trial nem grátis), no dia de Brasília. Só entram empresas criadas há até 400 dias.',
    caveat: 'Vendas recentes ainda não fecharam as janelas: elas saem do denominador e aparecem na nota abaixo da matriz. A lista de empresas travadas não usa este filtro.',
  },
  {
    key: 'filter.cohort',
    label: 'Coorte',
    whatIs: 'Como agrupar as empresas na tabela e no gráfico de coortes: pelo mês (padrão) ou pelo trimestre da primeira venda.',
    purpose: 'Comparar turmas de vendas entre si; o trimestre junta turmas pequenas e reduz a oscilação de amostra pequena.',
    howGenerated: 'Cada empresa entra na coorte do mês ou do trimestre do seu D0 (primeira venda, no dia de Brasília). As taxas de cada coorte usam só as janelas já fechadas.',
    caveat: 'Coorte com menos de 20 empresas aparece com a marca de amostra pequena.',
  },
  {
    key: 'filter.universe',
    label: 'Universo',
    whatIs: 'Quais empresas a Ativação lê: Vendidas (padrão), Não vendidas (sem nenhuma venda encontrada) ou Todas.',
    purpose: 'Medir a implantação de quem comprou ou comparar com quem só testou o produto.',
    howGenerated: 'Vendida é a empresa com D0 por registro de venda, funcionalidade da venda inicial, pagamento ou criação fora de trial. Empresas de teste criadas pelo Master sem registro de venda ficam fora de todas as opções.',
    caveat: 'Em Não vendidas e Todas, a opção "Vendida sem pagar" de Situação hoje passa a se chamar "Em trial". A lista de empresas travadas não usa este filtro.',
    seeAlso: ['filter.salePeriod'],
  },
  {
    key: 'filter.status',
    label: 'Situação hoje',
    whatIs: 'Situação atual da empresa: Ativas, Canceladas ou excluídas, ou Vendida sem pagar (ainda trial), que vira "Em trial" quando o universo inclui as não vendidas.',
    purpose: 'Separar quem comprou e segue ativo de quem já saiu, para ver se uma implantação ruim antecede o cancelamento.',
    howGenerated: 'Lida do retrato mais recente da empresa: cancelada ou excluída quando está excluída ou inativa; vendida sem pagar quando ainda está em trial; ativa nos demais casos.',
    caveat: 'É a situação de hoje, não a da época da venda. A lista de empresas travadas não usa este filtro.',
  },
  {
    key: 'filter.trial',
    label: 'Trial antes da venda',
    whatIs: 'Separa as empresas que passaram por período de teste antes da primeira venda (Com trial) das que compraram direto (Venda direta).',
    purpose: 'Comparar a implantação de quem testou antes de comprar com a de quem comprou sem testar.',
    howGenerated: 'Dias de trial são os dias entre a criação da empresa e o D0 (primeira venda). Com trial: mais de zero dias; venda direta: D0 no dia da criação.',
    caveat: 'Marcos feitos durante o trial contam como D+0. A lista de empresas travadas não usa este filtro.',
  },
  {
    key: 'filter.started',
    label: 'Só as que iniciaram o uso',
    whatIs: 'Mostra só as empresas que cadastraram pelo menos um colaborador até 60 dias depois da venda (ou até hoje, se esse prazo ainda não acabou).',
    purpose: 'Tirar da conta quem comprou e nunca começou, para medir a qualidade da implantação de quem de fato começou.',
    howGenerated: 'Usa a data do primeiro usuário com perfil de funcionário cadastrado (o dono da conta não conta), lida nos bancos dos clientes pelo processamento noturno da ativação.',
    caveat: 'A lista de empresas travadas não usa este filtro.',
  },
  {
    key: 'filter.plan',
    label: 'Plano (hoje)',
    whatIs: 'Plano atual da empresa no cadastro: Trial, Free, Até 10 ou Acima de 10 funcionários.',
    purpose: 'Comparar a ativação entre faixas de plano e achar onde a implantação mais trava.',
    howGenerated: 'Lido do campo de plano do cadastro da empresa, no retrato mais recente.',
    caveat: 'É o plano de hoje, não o da época da venda.',
  },
  {
    key: 'filter.journeyNow',
    label: 'Jornada (hoje)',
    whatIs: 'Etapa atual da empresa na jornada do cliente gravada no Master: Lead, Onboarding, Middle, Ongoing ou Resale.',
    purpose: 'Conferir se a etapa gravada pelo time bate com o avanço real nos marcos da ativação.',
    howGenerated: 'Lida do cadastro da empresa no retrato mais recente. É informativa: o PI não calcula a jornada.',
    caveat: 'É a jornada de hoje, não a da época da venda.',
    seeAlso: ['common.journey'],
  },
  {
    key: 'filter.origin',
    label: 'Origem',
    whatIs: 'Por onde a empresa foi criada: pelo Master (cadastro feito pelo time) ou pela landing page (cadastro feito pelo próprio cliente no site).',
    purpose: 'Comparar a implantação de quem foi cadastrado pelo time com a de quem chegou sozinho pelo site.',
    howGenerated: 'Lida do campo de origem do cadastro da empresa, no retrato mais recente.',
  },
  {
    key: 'filter.shard',
    label: 'Banco (shard)',
    whatIs: 'Código de 4 letras do banco de dados em que a empresa está, como AAAA ou NNNN. Shard é cada uma das partes em que as empresas clientes são divididas.',
    purpose: 'Isolar um banco ao investigar um problema de coleta ou de leitura que atinge só as empresas dele.',
    howGenerated: 'Vem do contexto da empresa no cadastro, o mesmo código mostrado abaixo do nome nas listas. O filtro compara o código inteiro, sem diferenciar maiúsculas de minúsculas.',
    seeAlso: ['common.shard'],
  },
  {
    key: 'filter.internal',
    label: 'Demonstração',
    whatIs: 'Quais empresas a lista mostra quanto à marca de demonstração: Ocultar (padrão, só o universo), Só demonstração, Sugestões (nome de teste ou âncora dos jobs, ainda sem a marca) ou Todas.',
    purpose: 'Conferir as empresas tiradas dos números e revisar as que talvez devam sair: "Sugestões" leva a cada uma pelo "Revisar".',
    howGenerated: 'Usa a marca de demonstração do retrato noturno mais recente do período. As marcadas entram só ativas e não excluídas, e aparecem sem atividade porque ficam fora de todos os números.',
    caveat: 'Só a lista de Empresas usa este filtro. Os contadores do cabeçalho não mudam com ele.',
    seeAlso: ['common.demo', 'companies.demoSuggestion'],
  },
];



// WEBPACK FOOTER //
// ./src/vue/pages/components/pi/glossary/filters.js